import React, { useState } from "react";
import { Container, Row, ButtonGroup, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AppPricingPlanTable from "./AppPricingPlanTable.jsx";
// import MoreInfoButton from "components/MoreInfoButton.jsx";

const plans = [
  {
    name: "基本",
    desc: "適合展示個人/公司形象",
    class: "order-md-first",
    content: ['內容管理系統', '模版式 設計', '社交平台 支援', '應用程式 安裝', '定期維護'],
    price: { monthly: 500, yearly: 400 }
  },
  {
    name: "自訂",
    desc: "根據公司現有項目進行維護/改進功能",
    class: "order-md-last",
    content: ['內容管理系統', '模版式設計', '手機應用程式編寫', '系統維護'],
    price: { monthly: 9999, yearly: 9999 }
  },
  {
    name: "手機應用及網站",
    desc: "適合公司產品系列推廣及銷售",
    content: ['內容管理系統', '模版式 設計', '社交平台 支援', '<b>雙平台應用程式 (iOS, Android)</b>', '應用程式 安裝'],
    price: { monthly: 880, yearly: 800 },
    best: true
  }
];

const AppPricingPlan = props => {
  const [basis, setBasis] = useState("monthly");

  return (
    <section className="section pricing-plans">
      <div className="shapes-container overflow-clear">
        <div className="shape shape-1" />
        <div className="shape shape-2" />
        <div className="shape shape-3" />
        <div className="shape shape-4" />

        <div className="icon-holder">
          <i className="icon pe pe-7s-cash pe-3x" />

          <FontAwesomeIcon
            icon={["fas", "dollar-sign"]}
            className="icon fa-3x"
          />

          <i className="icon pe pe-7s-piggy pe-3x" />

          <i className="icon pe pe-7s-cart pe-3x" />

          <FontAwesomeIcon
            icon={["far", "credit-card"]}
            className="icon fa-3x"
          />

          <FontAwesomeIcon
            icon={["far", "money-bill-alt"]}
            className="icon fa-3x"
          />
        </div>
      </div>

      <Container>
        <div className="section-heading text-center">
          <span className="rounded-pill shadow-box bold py-2 px-4">
            <FontAwesomeIcon
              icon={["far", "lightbulb"]}
              className="text-primary mr-2"
            />
            <span className="text-primary">不同服務計劃</span>，更容易控制成本
          </span>
          {/* <h2 className="mt-3 heading-line">產品列表</h2> */}
          <p className="lead text-muted">
            除應用程式註冊、上架及寄存費用外，<span className="highlight">沒有隱藏費用。</span>
          </p>

          <ButtonGroup>
            <Button
              color="secondary"
              onClick={e => setBasis("monthly")}
              active={basis === "monthly"}
            >
              六個月
            </Button>

            <Button
              color="secondary"
              onClick={e => setBasis("yearly")}
              active={basis === "yearly"}
            >
              一年
            </Button>
          </ButtonGroup>
        </div>

        <Row className="no-gutters align-items-center pricing-plans-options">
          {plans.map((plan, i) => (
            <AppPricingPlanTable {...plan} basis={basis} key={i} />
          ))}
        </Row>
      </Container>

      {/* <Container className="pt-0 border-bottom">
        <Row className="align-items-center">
          <Col md="8">
            <div className="text-center text-md-left">
              <h4 className="bold accent">Not sure what's better for you?</h4>
              <p className="mt-0">
                You can start for free, as long as you fell in love with our App
                you can decide what plan better suites your needs.{" "}
                <span className="italic dotted">
                  By picking any of the pay plans you'll get 30 days free trial.
                </span>
              </p>
            </div>
          </Col>

          <Col md="4" className="text-center text-md-right">
            <MoreInfoButton
              className="btn btn-primary btn-lg text-contrast p-4 ml-md-auto"
              text="Try it now !"
              to="#!"
            />
          </Col>
        </Row>
      </Container> */}
    </section>
  );
};

export default AppPricingPlan;


